import React from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'
import moment from 'moment'
import Pagination from 'react-js-pagination'
import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import ModalAddDelegados from '../components/Delegados/ModalAddDelegados'
import ModalDelete from '../components/Shared/ModalDelete'
import store from '../utils/store'
import ModalSelectorFromList from '../components/Shared/ModalSelectorFromList'

import FontAwesome from 'react-fontawesome'

import {
    getDelegados,
    toggleSelectAllItems,
    toggleSelectItem,
    showHideModalAddDelegados,
    deleteDelegados,
    changeRecordsToShow,
    setOrderBy
} from '../actions/delegados'
import { getParameterByName, showHideModalDelete } from '../actions/common';

const tableCols = [
    { Id: 0, Caption: "ID", Value: "id", Type: "number", Width:"4", LinkToEdit:true},
    { Id: 1, Caption: "Responsable del cenco", Value: "responsable_cenco.fullname", Type: "string", Width:"20" },
    { Id: 2, Caption: "Cenco", Value: "cenco.descripcion", Type: "string", Width:"24" },
    { Id: 3, Caption: "Tipo de solicitud", Value: "tipo_solicitud", Type: "string", Width:"32" },
    { Id: 4, Caption: "Nombre del delegado", Value: "delegado.fullname", Type: "string", Width:"20" },
    
]

function findValues(c, x) {
    let value = x.getIn(c.Value.split('.'))
    if (c.Value === "tipo_solicitud") {
        const solicitudes = store.getState().common.getIn(['parametros', 'SOLICITUDES'])
                .filter(x => value.indexOf(x.get('TIPO_SOLICITUD')) >= 0)
                .map(x => x.get('SOLICITUD'))

        value = solicitudes.join(', ')
    }
    
    return value
}

class Delegados extends React.Component {
    componentWillMount() {
        this.props.getParameterByName('SOLICITUDES')
        this.props.getDelegados()
    }

    render() {
        const { delegados, orderBy, page, totalRecords, showRecords } = this.props
        const boxActions = [
            <BoxButton key="ba[0]" name="plus-circle" onClick={e => this.props.showHideModalAddDelegados(true, 'Creación de Delegados', 'create')} title="Nuevo Delegado" />,
            <BoxButton key="ba[1]" name="trash" onClick={e => this.props.showHideModalDelete(true, `Esta seguro que desea eliminar los delegados seleccionados?`, () => this.props.deleteDelegados())} disabled={delegados.filter(x => x.get('checked')).count() === 0} danger title="Eliminar maestra" />,
        ]

        const pagination = <Pagination
            activePage={page}
            itemsCountPerPage={showRecords}
            totalItemsCount={totalRecords}
            pageRangeDisplayed={10}
            onChange={(pg) => this.props.getDelegados(pg)}
            firstPageText={<FontAwesome name="angle-double-left" />}
            prevPageText={<FontAwesome name="angle-left" />}
            nextPageText={<FontAwesome name="angle-right" />}
            lastPageText={<FontAwesome name="angle-double-right" />}
        />

        return (
            <div className="row" style={{ height: '100%' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <Box title="Asignación de delegados" stretch>

                        <ButtonStrip
                            actions={boxActions}
                            totalRecords={totalRecords}
                            showRecords={showRecords}
                            changeRecordsToShow={(records) => this.props.changeRecordsToShow(records)}
                            pagination={pagination}
                        />

                        <div className="box-content" style={{ flex: 1, height: 0, overflow: 'auto' }}>

                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-delegados">
                                <thead>
                                    <tr>
                                        <th width="20px">
                                            <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={e => this.props.toggleSelectAllItems(e.target.checked)} checked={delegados.filter(x => x.get('checked')).count() === delegados.count() || false } />
                                        </th>
                                        {
                                            tableCols.map(x => {
                                                const style = { width: `${x.Width}%` }
                                                return (
                                                    <th key={`th1[${x.Id}]`} style={style}>{x.Caption}</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>                                    
                                    {
                                        delegados.map((x, c) => {
                                            return (
                                                <tr key={`tr1[${x.get('id')}]`} className={x.get('checked') ? 'info' : ''}>
                                                    <td>
                                                        <input type="checkbox" style={{ verticalAlign: 'middle' }} onChange={e => this.props.toggleSelectItem(c, e.target.checked)} checked={x.get('checked') || false} />
                                                    </td>
                                                    {
                                                        tableCols.map(c => {
                                                            let alignment = 'left'
                                                            let value = findValues(c, x)

                                                            if (c.Type) {
                                                                switch (c.Type) {
                                                                    case 'bool':
                                                                        if (typeof value === 'string') value = parseInt(value, 10)
                                                                        value = <div style={{ textAlign: 'center', fontSize: '1.1em' }}><i className={`fa fa-${value ? 'check-' : ''}square`} /></div>
                                                                        break
                                                                    case 'number':
                                                                        value = numeral(value).format(c.Format)
                                                                        alignment = 'right'
                                                                        break
                                                                    case 'html':
                                                                        value = <div style={{ maxHeight: '10vh', overflowX: 'hidden' }} dangerouslySetInnerHTML={{ __html: value }} />
                                                                        break
                                                                    case 'datetime':
                                                                            value = value ? moment(value).format(c.Format) : '';
                                                                            alignment = 'right';
                                                                            break
                                                                    default:
                                                                }
                                                            }
                                                            const style = { textAlign: alignment, Width: c.Width+"%" }

                                                            if (c.LinkToEdit) {
                                                                return (
                                                                    <td key={`td1[${x.get('id')}][${c.Id}]`} className='LinkToEdit' style={style} onClick={e => this.props.showHideModalAddDelegados(true, 'Modificación de delegados', 'edit', x.get('id'))}>{value}</td>
                                                                )
                                                            } else {
                                                                return (
                                                                    <td key={`td1[${x.get('id')}][${c.Id}]`} style={style}>{value}</td>
                                                                )
                                                            }
                                                        })
                                                    }                                                 
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>                       
                        
                        </div>                
                    
                    </Box>
                </div>

                <ModalAddDelegados />
                <ModalDelete />
                <ModalSelectorFromList />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        delegados: state.delegados.get('delegados'),
        orderBy: state.delegados.get('orderBy'),
        totalRecords: state.delegados.get('totalRecords'),
        showRecords: state.delegados.get('showRecords'),
        page: state.delegados.get('page'),
        enums: state.common.get('enums').toJS(),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getDelegados: (page) => dispatch(getDelegados(page)),
        toggleSelectItem: (index, checked) => dispatch(toggleSelectItem(index, checked)),
        toggleSelectAllItems: (checked) => dispatch(toggleSelectAllItems(checked)),
        showHideModalAddDelegados: (show, title, action, id) => dispatch(showHideModalAddDelegados(show, title, action, id)),
        showHideModalDelete: (open, message, action, id) => dispatch(showHideModalDelete(open, message, action, id)),
        deleteDelegados: () => dispatch(deleteDelegados()),
        getParameterByName: (param) => dispatch(getParameterByName(param)),
        changeRecordsToShow: (records) => dispatch(changeRecordsToShow(records)),
        setOrderBy: (field) => dispatch(setOrderBy(field)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Delegados)


// WEBPACK FOOTER //
// ./src/containers/Delegados.jsx